import Toast from "react-native-toast-message";

import type { ThemedFeedbackWidthProps } from "./ThemedFeedback";
import { ToastContent } from "./ToastContent";

/**
 * Width behaviour of the toast card, forwarded to `ThemedFeedback`. Defaults to
 * the fixed 736px card
 */
type ThemedToastProps = ThemedFeedbackWidthProps;

export const ThemedToast = ({
  fluid,
  maxWidth,
  compact,
}: ThemedToastProps = {}) => {
  const widthProps: ThemedFeedbackWidthProps = fluid
    ? { fluid, maxWidth, compact }
    : {};

  return (
    <Toast
      config={
        {
          success: (props) => (
            <ToastContent
              {...props}
              text1={props.text1 ?? ""}
              text2={props.text2 ?? ""}
              onClose={
                props.props?.dismissible ? () => props.hide() : undefined
              }
              closeButtonLabel={props.props?.closeButtonLabel}
              {...widthProps}
            />
          ),
          error: (props) => (
            <ToastContent
              {...props}
              text1={props.text1 ?? ""}
              text2={props.text2 ?? ""}
              onClose={
                props.props?.dismissible ? () => props.hide() : undefined
              }
              closeButtonLabel={props.props?.closeButtonLabel}
              {...widthProps}
            />
          ),
          info: (props) => (
            <ToastContent
              {...props}
              text1={props.text1 ?? ""}
              text2={props.text2 ?? ""}
              onClose={
                props.props?.dismissible ? () => props.hide() : undefined
              }
              closeButtonLabel={props.props?.closeButtonLabel}
              {...widthProps}
            />
          ),
        } as const
      }
    />
  );
};

ThemedToast.show = Toast.show;
ThemedToast.hide = Toast.hide;
